import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getChatConversations = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'lastResponse', order: 'DESC' }})
    }

    return filterObjectStore(state.chat.conversations.entries, filter);
};
